export default __webpack_public_path__ + "static/media/twitterw.de4a3d5f.svg";